import LangEnum from '../lang/LangEnum';
import { OrderView } from '../modules/orders/ordersView.types';

const MAIN_PATHS = {
  home: {
    path: '/',
    pageTitleKey: LangEnum.GLOBAL_TECEO,
  },
  rachel: {
    path: '/rachel',
    pageTitleKey: LangEnum.MAIN_DRAWER_RACHEL,
  },
  myNetwork: {
    path: '/connections',
    pageTitleKey: LangEnum.MY_NETWORK_CONNECTIONS,
  },
  showroom: {
    path: '/:slug',
  },
  adminTeceo: {
    path: '/admin',
  },
  reports: {
    path: '/reports',
    pageTitleKey: LangEnum.GLOBAL_REPORTS,
  },
  analytics: {
    path: '/analytics',
    pageTitleKey: LangEnum.GLOBAL_ANALYTICS,
  },
  settings: {
    path: '/settings',
    pageTitleKey: LangEnum.MAIN_DRAWER_SETTINGS,
  },
  customers: {
    path: '/customers',
    pageTitleKey: LangEnum.GLOBAL_CUSTOMERS,
    form: {
      path: '/customers/:id',
      pageTitleKey: LangEnum.GLOBAL_CUSTOMER,
    },
  },
  salesOpportunities: {
    path: '/sales-opportunities',
    pageTitleKey: LangEnum.SALES_OPPORTUNITIES,
    new: {
      path: '/sales-opportunities/new',
    },
    form: {
      path: '/sales-opportunities/:id',
      pageTitleKey: LangEnum.GLOBAL_SALES_OPPORTUNITY,
      values: {
        path: '/sales-opportunities/:id/values',
      },
    },
  },
  targets: {
    list: {
      path: '/plans',
      pageTitleKey: LangEnum.GLOBAL_PLANS,
    },
    form: {
      path: '/plans/:targetId',
      pageTitleKey: LangEnum.GLOBAL_PLAN,
    },
  },
  legacyTargets: {
    path: '/targets/:listType',
    form: {
      path: '/targets/:listType/:targetId',
    },
  },
  products: {
    path: '/products',
  },
  catalogs: {
    path: '/catalogs',
    pageTitleKey: LangEnum.CATALOGS_TITLE,
    products: {
      path: '/catalogs/:id/products',
      pageTitleKey: LangEnum.GLOBAL_CATALOG,
    },
  },
  orders: {
    path: '/orders',
    pageTitleKey: LangEnum.GLOBAL_ORDERS,
    editForm: {
      redirect: '/orders/:id',
      pageTitleKey: LangEnum.GLOBAL_ORDER,
      path: `/orders/:id/${OrderView.EDIT}`,
    },
    finished: {
      path: `/orders/:id/${OrderView.FINISHED}`,
      pageTitleKey: LangEnum.GLOBAL_ORDER,
    },
    suggestion: {
      path: `/orders/:id/${OrderView.SUGGESTION}`,
      pageTitleKey: LangEnum.SUGGESTED_ORDER,
    },
    contract: {
      sign: {
        ptBR: {
          path: '/assinar-contrato/:id',
        },
        enUS: {
          path: '/sign-contract/:id',
        },
      },
    },
  },
  storeOrders: {
    path: '/store-orders',
    pageTitleKey: LangEnum.STORE_ORDERS_TITLE,
  },
  invoices: {
    path: '/invoices',
    pageTitleKey: LangEnum.INVOICES_TITLE,
  },
  events: {
    path: '/events/:slug',
  },
  showroomStorefront: {
    path: '/:slug',
  },
  storefront: {
    path: '',
  },
  accountsReceivable: {
    receivable: {
      path: '/accounts-receivable',
      pageTitleKey: LangEnum.ACCOUNTS_RECEIVABLE_TITLE,
    },
    payable: {
      path: '/accounts-payable',
      pageTitleKey: LangEnum.ACCOUNTS_RECEIVABLE_PAYABLE_TITLE,
    },
  },
  cases: {
    path: '/cases',
    pageTitleKey: LangEnum.GLOBAL_CASES,
    form: {
      path: '/cases/:id',
      pageTitleKey: LangEnum.GLOBAL_CASE,
    },
  },
  casesByType: {
    path: '/cases/types/:caseTypeId',
  },
};

const SETTINGS_PATHS = {
  licenses: {
    path: '/settings/licenses',
    pageTitleKey: LangEnum.GLOBAL_LICENSES,
  },
  brand: {
    path: '/settings/brand',
    pageTitleKey: LangEnum.GLOBAL_REGISTRATION,
    addresses: {
      path: '/settings/brand/addresses',
    },
    images: {
      path: '/settings/brand/images',
    },
  },
  store: {
    path: '/settings/store',
  },
  mercadologicalTree: {
    path: '/settings/mercadological-tree',
    pageTitleKey: LangEnum.GLOBAL_MERCADOLOGICAL_TREE,
  },
  productMatches: {
    path: '/settings/product-matches',
    pageTitleKey: LangEnum.GLOBAL_PRODUCT_MATCH,
  },
  productRegistrations: {
    path: '/settings/product-registrations',
    pageTitleKey: LangEnum.GLOBAL_PRODUCT_REGISTRATION,
  },
  stock: {
    path: '/settings/stock',
    pageTitleKey: LangEnum.GLOBAL_READY_FOR_DELIVERY,
  },
  locals: {
    path: '/settings/locals',
    pageTitleKey: LangEnum.LOCALS,
    new: {
      path: '/settings/locals/new',
    },
    form: {
      path: '/settings/locals/:id',
      address: {
        path: '/settings/locals/:id/address',
      },
    },
  },
  shippingCompanies: {
    path: '/settings/shipping-companies',
    pageTitleKey: LangEnum.SHIPPING_COMPANIES,
    new: {
      path: '/settings/shipping-companies/new',
    },
    form: {
      path: '/settings/shipping-companies/:id',
    },
  },
  products: {
    path: '/settings/products',
    pageTitleKey: LangEnum.GLOBAL_PRODUCTS,
    form: {
      path: '/settings/products/:id',
      pageTitleKey: LangEnum.GLOBAL_PRODUCT,
      new: {
        path: '/settings/products/new',
      },
      category: {
        path: '/settings/products/:id/category',
      },
      variations: {
        path: '/settings/products/:id/variations',
      },
      skus: {
        path: '/settings/products/:id/skus',
      },
      preOrder: {
        path: '/settings/products/:id/pre-order',
      },
      stock: {
        path: '/settings/products/:id/stock',
      },
      futureInventory: {
        path: '/settings/products/:id/future-inventory',
      },
      media: {
        path: '/settings/products/:id/media',
      },
      colors: {
        path: '/settings/products/:id/colors',
      },
      packs: {
        path: '/settings/products/:id/packs',
      },
      packInventory: {
        path: '/settings/products/:id/pack-inventory',
      },
    },
  },
  kits: {
    path: '/settings/kits',
    form: {
      path: '/settings/kits/:id',
    },
  },
  skus: {
    path: '/settings/skus',
    pageTitleKey: LangEnum.GLOBAL_SKUS,
  },
  preOrder: {
    path: '/settings/pre-order',
    pageTitleKey: LangEnum.GLOBAL_PRE_ORDER,
  },
  imports: {
    path: '/settings/imports',
    pageTitleKey: LangEnum.GLOBAL_FILE_IMPORTS,
    form: {
      path: '/settings/imports/:id',
    },
  },
  sizes: {
    path: '/settings/sizes',
    pageTitleKey: LangEnum.GLOBAL_SIZES,
  },
  grids: {
    path: '/settings/grids',
    pageTitleKey: LangEnum.GLOBAL_GRIDS,
    form: {
      path: '/settings/grids/:id',
      pageTitleKey: LangEnum.GLOBAL_GRIDS,
      new: {
        path: '/settings/grids/new',
      },
      packs: {
        path: '/settings/grids/:id/packs',
      },
    },
  },
  packs: {
    path: '/settings/packs',
    pageTitleKey: LangEnum.GLOBAL_PACKS,
  },
  colors: {
    path: '/settings/colors',
    pageTitleKey: LangEnum.GLOBAL_COLORS,
    new: {
      path: '/settings/colors/new',
    },
    form: {
      path: '/settings/colors/:id',
      pageTitleKey: LangEnum.GLOBAL_COLOR,
    },
  },
  productColor: {
    form: {
      path: `colors/:id`,
    },
  },
  customerGroups: {
    path: '/settings/customer-groups',
    pageTitleKey: LangEnum.GLOBAL_CUSTOMERS_GROUPS,
    new: {
      path: '/settings/customer-groups/new',
    },
    form: {
      path: '/settings/customer-groups/:id',
      pageTitleKey: LangEnum.CUSTOMERS_FILTER_GROUP,
    },
  },
  salesRepresentatives: {
    path: '/settings/sales-representatives',
    pageTitleKey: LangEnum.GLOBAL_SALES_REPRESENTATIVES,
    form: {
      path: '/settings/sales-representatives/:id',
      pageTitleKey: LangEnum.GLOBAL_SALES_REPRESENTATIVE,
      new: {
        path: '/settings/sales-representatives/new',
      },
      sellers: {
        path: '/settings/sales-representatives/:id/sellers',
      },
      priceTables: {
        path: '/settings/sales-representatives/:id/price-tables',
      },
    },
  },
  salesTargets: {
    path: '/settings/sales-targets',
    pageTitleKey: LangEnum.GLOBAL_SALES_TARGETS,
    new: {
      path: '/settings/sales-targets/new',
    },
    form: {
      path: '/settings/sales-targets/:id',
      pageTitleKey: LangEnum.GLOBAL_SALES_TARGET,
    },
  },
  sellers: {
    path: '/settings/sellers',
    form: {
      path: '/settings/sellers/:id',
    },
  },
  consultants: {
    path: '/settings/consultants',
    pageTitleKey: LangEnum.GLOBAL_CONSULTANTS,
    form: {
      path: '/settings/consultants/:id',
      pageTitleKey: LangEnum.GLOBAL_CONSULTANT,
      new: {
        path: '/settings/consultants/new',
      },
    },
  },
  priceTables: {
    path: '/settings/price-tables',
    pageTitleKey: LangEnum.PRICE_TABLES,
    new: {
      path: '/settings/price-tables/new',
    },
    form: {
      path: '/settings/price-tables/:id',
      pageTitleKey: LangEnum.GLOBAL_PRICE_TABLE,

      products: {
        path: '/settings/price-tables/:id/products',
      },
    },
  },
  categories: {
    path: '/settings/categories',
    pageTitleKey: LangEnum.GLOBAL_CATEGORIES,
    new: {
      path: '/settings/categories/new',
    },
    subcategories: {
      path: '/settings/categories/new/:parentId',
      pageTitleKey: LangEnum.GLOBAL_SUBCATEGORY,
    },
    form: {
      path: '/settings/categories/:id',
      pageTitleKey: LangEnum.GLOBAL_CATEGORY,
    },
  },
  paymentMethods: {
    path: '/settings/payment-methods',
    pageTitleKey: LangEnum.CUSTOMER_PAYMENT_METHODS_ADD_MODAL_TITLE,
    new: {
      path: '/settings/payment-methods/new',
    },
    form: {
      path: '/settings/payment-methods/:id',
      pageTitleKey: LangEnum.GLOBAL_PAYMENT_METHOD,
    },
  },
  collections: {
    path: '/settings/collections',
    pageTitleKey: LangEnum.GLOBAL_COLLECTIONS,
    form: {
      path: '/settings/collections/:id',
      pageTitleKey: LangEnum.GLOBAL_COLLECTION,
      new: {
        path: '/settings/collections/new',
      },
    },
  },
  deliveryWindows: {
    path: '/settings/delivery-windows',
    pageTitleKey: LangEnum.GLOBAL_DELIVERY_WINDOWS,
    form: {
      path: '/settings/delivery-windows/:id',
      pageTitleKey: LangEnum.GLOBAL_DELIVERY_WINDOW,
      new: {
        path: '/settings/delivery-windows/new',
      },
    },
  },
  classifications: {
    path: '/settings/classifications',
    pageTitleKey: LangEnum.GLOBAL_PRODUCTS_CLASSIFICATIONS,
    new: {
      path: '/settings/classifications/new',
    },
    form: {
      path: '/settings/classifications/:id',
      pageTitleKey: LangEnum.GLOBAL_PRODUCTS_CLASSIFICATION,
    },
  },
  classificationsCustomer: {
    path: '/settings/classifications-customers',
    pageTitleKey: LangEnum.GLOBAL_CUSTOMERS_CLASSIFICATIONS,
    form: {
      path: '/settings/classifications-customers/:id',
      pageTitleKey: LangEnum.GLOBAL_CUSTOMER_CLASSIFICATION,
      new: {
        path: '/settings/classifications-customers/new',
      },
    },
  },
  commercialPolicies: {
    path: '/settings/commercial-policy',
    pageTitleKey: LangEnum.GLOBAL_COMMERCIAL_POLICIES,
    form: {
      path: '/settings/commercial-policy/:id',
      pageTitleKey: LangEnum.GLOBAL_COMMERCIAL_POLICY,
      customers: {
        path: '/settings/commercial-policy/:id/customers',
      },
      new: {
        path: '/settings/commercial-policy/new',
      },
    },
  },
  businessPolicies: {
    path: '/settings/business-policies',
    pageTitleKey: LangEnum.GLOBAL_BUSINESS_POLICIES,
    new: {
      path: '/settings/business-policies/new',
    },
    form: {
      path: '/settings/business-policies/:id',
      pageTitleKey: LangEnum.GLOBAL_BUSINESS_POLICY,
    },
  },
  futureStock: {
    path: '/settings/future-stock',
    pageTitleKey: LangEnum.GLOBAL_FUTURE_STOCK,
  },
  materialPreOrder: {
    path: '/settings/material-pre-order',
    pageTitleKey: LangEnum.GLOBAL_MATERIAL_PRE_ORDER,
  },
  profile: {
    path: '/settings/profile',
    pageTitleKey: LangEnum.MAIN_DRAWER_MY_ACCOUNT,
    teams: {
      path: '/settings/profile/teams',
    },
  },
  promotions: {
    path: '/settings/promotions',
    pageTitleKey: LangEnum.GLOBAL_PROMOTIONS,
    new: {
      path: '/settings/promotions/new',
    },
    form: {
      path: '/settings/promotions/:id',
      pageTitleKey: LangEnum.GLOBAL_PROMOTION,
      skus: {
        path: '/settings/promotions/:id/skus',
      },
    },
  },
  materials: {
    path: '/settings/materials',
    pageTitleKey: LangEnum.GLOBAL_MATERIAL_PRE_ORDER,
    new: {
      path: '/settings/materials/new',
    },
    form: {
      path: '/settings/materials/:id',
      pageTitleKey: LangEnum.GLOBAL_MATERIAL_PRE_ORDER,
    },
  },
  materialStock: {
    path: '/settings/material-stock',
    pageTitleKey: LangEnum.MATERIAL_STOCK_MENU,
  },
  generalSettings: {
    path: '/settings/general-settings',
    pageTitleKey: LangEnum.GLOBAL_GENERAL_DEFINITIONS,
  },
  dropbox: {
    path: '/settings/dropbox',
  },
  instagram: {
    path: '/settings/instagram',
  },
  users: {
    path: '/settings/users',
    pageTitleKey: LangEnum.GLOBAL_USERS,
  },
  userGroups: {
    path: '/settings/user-groups',
    pageTitleKey: LangEnum.USER_CONTEXT_GROUPS,
    new: {
      path: '/settings/user-groups/new',
    },
    form: {
      path: '/settings/user-groups/:id',
      pageTitleKey: LangEnum.USER_CONTEXT_GROUP,
      users: {
        path: '/settings/user-groups/:id/users',
      },
    },
  },
  integrations: {
    path: '/settings/integrations',
    pageTitleKey: LangEnum.GLOBAL_ERP_SYSTEM,
    new: {
      path: '/settings/integrations/new',
    },
    form: {
      path: '/settings/integrations/:id',
      pageTitleKey: LangEnum.GLOBAL_ERP_SYSTEM,
    },
  },
  paymentGatewayIntegrations: {
    path: '/settings/payment-gateways',
    pageTitleKey: LangEnum.GLOBAL_PAYMENT_GATEWAY,
    new: {
      path: '/settings/payment-gateways/new',
    },
    form: {
      path: '/settings/payment-gateways/:id',
      pageTitleKey: LangEnum.GLOBAL_PAYMENT_GATEWAY,
    },
  },
  tmsIntegrations: {
    path: '/settings/tms-integrations',
    pageTitleKey: LangEnum.GLOBAL_TMS_SYSTEMS,
    new: {
      path: '/settings/tms-integrations/new',
    },
    form: {
      path: '/settings/tms-integrations/:id',
      pageTitleKey: LangEnum.GLOBAL_TMS_SYSTEM,
    },
  },
  webhooks: {
    path: '/settings/webhooks',
    pageTitleKey: LangEnum.GLOBAL_WEBHOOK_INTEGRATION,
    new: {
      path: '/settings/webhooks/new',
    },
    form: {
      path: '/settings/webhooks/:id',
      pageTitleKey: LangEnum.GLOBAL_WEBHOOK_INTEGRATION,
    },
  },
  reportPermissions: {
    path: '/settings/analytics-permissions',
    pageTitleKey: LangEnum.LIGHTDASH_REPORTS_PERMISSIONS,
  },
  storeIntegrationConfig: {
    path: '/settings/store-integration-config',
    pageTitleKey: LangEnum.STORE_INTEGRATION_CONFIG_PAGE_TITLE,
  },
};

const ADMIN_PATHS = {
  adminBanners: {
    path: '/admin/banners',
    form: {
      path: '/admin/banners/:id',
    },
  },
  adminAnnouncements: {
    path: '/admin/announcements',
    form: {
      path: '/admin/announcements/:id',
    },
  },
  adminHighlights: {
    path: '/admin/highlights',
    form: {
      path: '/admin/highlights/:id',
    },
  },
  adminBrands: {
    path: '/admin/brands',
    form: {
      path: '/admin/brands/:id',
    },
  },
  adminUsers: {
    path: '/admin/users',
    form: {
      path: '/admin/users/:id',
    },
  },
  adminStores: {
    path: '/admin/stores',
    form: {
      path: '/admin/stores/:id',
    },
  },
  adminTags: {
    path: '/admin/tags',
    form: {
      path: '/admin/tags/:id',
    },
  },
  adminParams: {
    path: '/admin/params',
  },
  adminTeceoUsers: {
    path: '/admin/teceo-users',
    form: {
      path: '/admin/teceo-users/:id',
    },
  },
  adminIntegrations: {
    path: '/admin/integrations',
  },
};

const REPORTS_PATHS = {
  report: {
    path: '/reports',
    pageTitleKey: LangEnum.GLOBAL_REPORTS,
    productSales: {
      path: '/reports/product-sales',
      suffixTitleKey: LangEnum.GLOBAL_PER_PRODUCT,
    },
    productColorSales: {
      path: '/reports/product-color-sales',
      suffixTitleKey: LangEnum.GLOBAL_PER_PRODUCT_COLOR,
    },
    productColorDeliveryWindowSales: {
      path: '/reports/product-color-delivery-window-sales',
      suffixTitleKey: LangEnum.REPORT_CARD_PRODUCT_COLOR_DELIVERY_WINDOW_SALES_TITLE,
    },
    orderSales: {
      path: '/reports/order-sales',
      suffixTitleKey: LangEnum.REPORT_CARD_ORDER_INCOME_TITLE,
    },
    orderItemsSales: {
      path: '/reports/order-items-sales',
      suffixTitleKey: LangEnum.REPORT_CARD_ORDER_ITEMS_SALES_TITLE,
    },
    orderIncome: {
      path: '/reports/order-income',
      suffixTitleKey: LangEnum.REPORT_CARD_ORDER_SALES_TITLE,
    },
    orderItemsIncome: {
      path: '/reports/order-items-income',
      suffixTitleKey: LangEnum.REPORT_CARD_ORDER_ITEMS_SALES_TITLE,
    },
    orderIncomeByCustomer: {
      path: '/reports/order-income-by-customer',
      suffixTitleKey: LangEnum.REPORT_CARD_ORDER_INCOME_BY_CUSTOMER_TITLE,
    },
    representativeSales: {
      path: '/reports/representative-sales',
      suffixTitleKey: LangEnum.REPORT_CARD_REPRESENTATIVE_SALES_TITLE,
    },
    salesCollection: {
      path: '/reports/sales-collection',
      suffixTitleKey: LangEnum.REPORT_CARD_SALES_COLLECTION_TITLE,
    },
    categorySales: {
      path: '/reports/category-sales',
      suffixTitleKey: LangEnum.REPORT_SALES_BY_CATEGORY,
    },
    subcategorySales: {
      path: '/reports/subcategory-sales',
      suffixTitleKey: LangEnum.REPORT_CARD_SUBCATEGORY_SALES_TITLE,
    },
    salesReportByProductClassification: {
      path: '/reports/sales-by-product-classification',
      suffixTitleKey: LangEnum.REPORT_CARD_SALES_BY_PRODUCT_CLASSIFICATION_TITLE,
    },
    customerSales: {
      path: '/reports/customer-sales',
      suffixTitleKey: LangEnum.REPORT_CARD_CUSTOMER_SALES_TITLE,
    },
    periodSales: {
      path: '/reports/period-sales',
      suffixTitleKey: LangEnum.REPORT_CARD_PERIOD_SALES_TITLE,
    },
    salesTargetSalesRep: {
      path: '/reports/sales-target-sales-rep',
      suffixTitleKey: LangEnum.REPORT_CARD_SALES_TARGET_SALES_REP_ORDERS_TITLE,
    },
    productSelloutSales: {
      path: '/reports/product-sellout-sales',
      suffixTitleKey: LangEnum.GLOBAL_PER_PRODUCT,
    },
    productColorSelloutSales: {
      path: '/reports/product-color-sellout-sales',
      suffixTitleKey: LangEnum.GLOBAL_PER_PRODUCT_COLOR,
    },
    orderSalesBySupplier: {
      path: '/reports/order-sales-by-supplier',
      suffixTitleKey: LangEnum.REPORT_CARD_ORDER_SALES_TITLE,
    },
    orderItemsSalesBySupplier: {
      path: '/reports/order-items-sales-by-supplier',
      suffixTitleKey: LangEnum.REPORT_CARD_ORDER_ITEMS_SALES_TITLE,
    },
    lightdashReports: {
      path: '/analytics/lightdash',
      pageTitleKey: LangEnum.GLOBAL_ANALYTICS,
      suffixTitleKey: LangEnum.LIGHTDASH_REPORTS_TITLE,
      dashboard: {
        path: '/analytics/lightdash/:dashboardId',
        suffixTitleKey: LangEnum.LIGHTDASH_REPORTS_TITLE,
      },
    },
  },
};

const PUBLIC_PATHS = {
  notFound: {
    path: '/not-found',
  },
  serverError: {
    path: '/server-error',
  },
  oauthLogin: {
    path: '/oauth/login',
  },
  oauthConsent: {
    path: '/oauth/consent',
  },
  ssoCallback: {
    path: '/:slug/sso/callback',
  },
  login: {
    path: '/login',
  },
  recoverPassword: {
    path: '/recover-password',
  },
  resetPassword: {
    path: '/reset-password',
  },
  signUp: {
    path: '/sign-up',
  },
  storeSignUp: {
    path: '/store-sign-up',
  },
  recuperarSenha: {
    path: '/recuperar-senha',
  },
  resetarSenha: {
    path: '/resetar-senha',
  },
  cadastreSe: {
    path: '/cadastre-se',
  },
  cadastrarLoja: {
    path: '/cadastrar-loja',
  },
  catalog: {
    path: '/:slug/share/catalog/:id',
  },
  order: {
    path: '/:slug/share/order/:id/suggestion',
  },
};

const OFFLINE_PATHS = {
  orders: {
    name: 'list-orders',
    path: '/orders',
    editForm: {
      path: `/orders/:id/${OrderView.EDIT}`,
    },
    finished: {
      path: `/orders/:id/${OrderView.FINISHED}`,
    },
  },
  loggedNoData: {
    path: '/offline',
  },
  catalogs: {
    name: 'catalogs',
    path: '/catalogs',
    products: {
      path: '/catalogs/:id/products',
    },
  },
};

const PUBLIC_OFFLINE_PATHS = {
  noData: {
    path: '/',
  },
};

const PATHS = {
  main: MAIN_PATHS,
  admin: ADMIN_PATHS,
  public: PUBLIC_PATHS,
  reports: REPORTS_PATHS,
  settings: SETTINGS_PATHS,
  offline: OFFLINE_PATHS,
  publicOffline: PUBLIC_OFFLINE_PATHS,
};

export default PATHS;
